const accessibility = {
	fontSizeCookieName : 'stjacques-fontsize',
	dyslexiaCookieName : 'stjacques-dyslexia',

	init : function(){

		// Font size event
		this.sizeRangeInput = document.getElementById('agrandissement-texte');
		if( this.sizeRangeInput ){
			this.sizeRangeInput.addEventListener('change', accessibility.updateFontSize);
			// accessibility.updateFontSize();
		}

		// Dyslexia event
		this.dyslexiaCheckbox = document.getElementById('dyslexie');
		if( this.dyslexiaCheckbox ){
			this.dyslexiaCheckbox.addEventListener('change', accessibility.updateDyslexia);
			// accessibility.updateDyslexia();
		}

		// Init values from cookies
		this.initValues();
	},

	initValues : function(){
		let dyslexiaValue = false;
		let fontSizeValue = 0;

		let cookies = document.cookie;
		if( cookies ){
			dyslexiaValue = accessibility.getCookie(accessibility.dyslexiaCookieName);
			if(  accessibility.dyslexiaCheckbox ){
				accessibility.dyslexiaCheckbox.checked = Boolean(dyslexiaValue);
			}

			fontSizeValue = accessibility.getCookie(accessibility.fontSizeCookieName);
			if( fontSizeValue && accessibility.sizeRangeInput ){
				accessibility.sizeRangeInput.value = fontSizeValue;
			}
		}
		accessibility.setDyslexia( Boolean(dyslexiaValue) );
		accessibility.setFontSize( fontSizeValue );
	},

	updateDyslexia : function(){
		accessibility.setCookie(
			accessibility.dyslexiaCookieName,
			accessibility.dyslexiaCheckbox.checked
		);
		accessibility.setDyslexia(accessibility.dyslexiaCheckbox.checked);
	},

	setDyslexia : function(setDyslexia = true){
		document.querySelector('html').style.fontFamily = (setDyslexia ? "Open Dyslexic" : "Helvetica");
	},

	updateFontSize : function(){
		accessibility.setCookie(
			accessibility.fontSizeCookieName,
			accessibility.sizeRangeInput.value
		);
		accessibility.setFontSize(accessibility.sizeRangeInput.value);
	},

	setFontSize : function(fontSize = 0){
		let value = 16 * (1 + (0.15 * fontSize));
		document.querySelector('html').style.fontSize = value+"px";
	},

	setCookie(name, value){
		document.cookie = name + "=" + (value || "") + "; path=/";
	},

	getCookie : function(name) {
		const value = ';'+document.cookie;
		const parts = value.split('; '+name+'=');
		if (parts.length === 2) return parts.pop().split(';').shift();
	}
}

export default accessibility;